import React from 'react';
import UploadManager from 'components/UploadManager';

const LowesSurveyUploads = () =>
  <UploadManager
    uploadType="lowes_survey_uploads"
    title="Lowe's C&P"
  />;

export default LowesSurveyUploads;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/lowesSurveyUploads/index.jsx